export function SettingsPageShell({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-8">
      <header className="flex flex-col gap-1">
        <h1 className="text-[22px] font-semibold text-foreground">{title}</h1>
        <p className="text-[13px] text-neutral-dim">{description}</p>
      </header>

      {children ? children : <p className="text-sm text-muted-foreground">Coming soon.</p>}
    </div>
  );
}
